import { Box, Grid, Stack } from "@mui/material";
import { Form, Formik } from "formik";
import { useTranslation } from 'react-i18next';

import ButtonWrapper from "../../FormUI/ButtonWrapper/ButtonWrapper";
import SubmitWrapper from "../../FormUI/SubmitWrapper/SubmitWrapper";

import TextfieldWrapper from "../../FormUI/Textfield/TextfieldWrapper";
import SearchIcon from '@mui/icons-material/Search';
import UndoIcon from '@mui/icons-material/Undo';
import DateTimePickerWrapper from "../../FormUI/DateTimePickerWrapper/DateTimePickerWrapper";

export default function Filters({
    handleOnSearch
}) {
    const { t } = useTranslation();

    const initialFormState = {
        invoice_code__icontains: '',
        paid_at__date__gte: '',
        paid_at__date__lte: ''
    };

    return (
        <Formik
            initialValues={{
                ...initialFormState
            }}
            onSubmit={handleOnSearch}
        >
            {({ handleReset, handleSubmit }) => (<Form>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <TextfieldWrapper
                            name="invoice_code__icontains"
                            label={t('Invoice Nº')}
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <DateTimePickerWrapper
                            name="paid_at__date__gte"
                            label={t('From date')}
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <DateTimePickerWrapper
                            name="paid_at__date__lte"
                            label={t('To date')}
                            size="small"
                        />
                    </Grid>

                    <Box width="100%" />

                    <Grid item xs={12}>
                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                            <SubmitWrapper startIcon={<SearchIcon />}>{t('Search')}</SubmitWrapper>
                            <ButtonWrapper
                                onClick={() => {
                                    handleReset();
                                    handleSubmit();
                                }}
                                variant="text"
                                startIcon={<UndoIcon />}>{t('Reset')}</ButtonWrapper>
                        </Stack>
                    </Grid>
                </Grid>
            </Form>)}
        </Formik>
    )
}
